/* eslint-disable indent */
import React from 'react'
import { Box } from '@mui/material'
import {
  SimpleSelect,
  Prompt,
  AutocompleteSelect,
  StepContent
} from '../components'
import ages from '../data/ages'
import countries from '../data/countries'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing }) => ({
  countries: {
    marginBottom: spacing(4)
  }
}))

const Step1Content = ({ data, onChange }) => {
  const classes = useStyles()

  // Windows 10/11 doesn't include flag emojis.
  const countryToFlag = isoCode => {
    const emoji =
      typeof String.fromCodePoint !== 'undefined'
        ? isoCode
            .toUpperCase()
            .replace(/./g, char =>
              String.fromCodePoint(char.charCodeAt(0) + 127397)
            )
        : ''
    return emoji === isoCode ? '' : emoji
  }

  const renderOption = (props, option) => (
    <li {...props}>
      <Box display='flex' alignItems='baseline' flexDirection='row'>
        <span>{countryToFlag(option.code)}</span>
        {option.label}
      </Box>
    </li>
  )

  return (
    <StepContent>
      <Prompt
        prompt='What is your country?'
        data-test='lpq-step1-country-prompt'
      />
      <AutocompleteSelect
        options={countries}
        value={data.country || null}
        onChange={value => onChange({ data: 'country', value })}
        fullWidth
        autoFocus
        placeholder='Select Country'
        renderOption={renderOption}
        classes={{ root: classes.countries }}
        data-test='lpq-step1-country-select'
      />
      <Prompt prompt='What is your age?' data-test='lpq-step1-age-prompt' />
      <SimpleSelect
        options={ages}
        value={data.age || null}
        onChange={value => onChange({ data: 'age', value })}
        aria-label='user-age'
        data-test='lpq-step1-age'
      />
    </StepContent>
  )
}

export default Step1Content
